import React, { useState, useContext } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import ToggleModal from "./ToggleModal";
import { apiUrl } from "../../../services/constants";
import MainContext from "../../../context/Main";
import ProductPlaceholder from "../common-components/Placeholders";
import { Link } from "react-router-dom";
import PacifierPicture from "./PacifierPicture";

export default function Products({ products, justifyContent = "" }) {
    const {
        selectProductName,
        selectPdfUrl,
        setSelectProductName,
        setSelectPdfUrl,
    } = useContext(MainContext);

    const handleModalClick = (name, pdfUrl) => {
        setSelectProductName(name);
        setSelectPdfUrl(pdfUrl);
    };

    {
        /* instead of a block of div inside the map <ProductPlaceholder key={products.id}/> */
    }
    return (
        <ToggleModal name={selectProductName} url={selectPdfUrl}>
            <div
                className={`row row-cols-2 row-cols-lg-5 g-2 g-lg-3 ${justifyContent}`}
            >
                {products.length !== 0 &&
                    products.map((product) => {
                        return (
                            <div
                                key={product.id}
                                className="col-xl-2 col-lg-2 col-md-4 col-sm-6 themed-grid-col text-center"
                            >
                                <div>
                                    {product.attributes.image.data?.attributes
                                        ?.url ? (
                                        <LazyLoadImage
                                            src={
                                                apiUrl +
                                                product.attributes.image.data
                                                    ?.attributes?.url
                                            }
                                            width={150}
                                            height="auto"
                                            effect="opacity"
                                        />
                                    ) : (
                                        <PacifierPicture />
                                    )}
                                </div>
                                <p>
                                    {product.attributes.title} |{" "}
                                    <a
                                        href={
                                            apiUrl +
                                            product.attributes.spec_pdf.data[0]
                                                ?.attributes?.url
                                        }
                                        target="_blank"
                                    >
                                        SPEC
                                    </a>
                                </p>
                                <button
                                    onClick={() => {
                                        handleModalClick(
                                            product.attributes.title,
                                            apiUrl +
                                                product.attributes.spec_pdf
                                                    .data[0]?.attributes?.url
                                        );
                                    }}
                                    type="button"
                                    className="btn btn-outline-dark border-0 btn-email-spec border-dark"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                >
                                    Email Spec
                                </button>
                            </div>
                        );
                    })}
            </div>
        </ToggleModal>
    );
}
